(function() {
    'use strict';
    Odigeo.UIElements.drawArrow = function(el, arrow) {
        var fill;
        var stroke;
        if ($(el).hasClass('ui-arrow-color')) {
            fill = $(el).css('fill');
            stroke = $(el).css('stroke');
        } else {
            stroke = 'rgba(0, 0, 0, 0)';
            fill = '#165218';
        }
        var arrows = {
            right: function(ctx) {
                ctx.save();
                ctx.beginPath();
                ctx.moveTo(0, 0);
                ctx.lineTo(64, 0);
                ctx.lineTo(64, 18);
                ctx.lineTo(0, 18);
                ctx.closePath();
                ctx.clip();
                ctx.strokeStyle = stroke;
                ctx.lineCap = 'butt';
                ctx.lineJoin = 'miter';
                ctx.miterLimit = 4;
                ctx.save();
                ctx.restore();
                ctx.save();
                ctx.translate(-261.38205, -283.86724);
                ctx.save();
                ctx.save();
                ctx.fillStyle = fill;
                ctx.strokeStyle = stroke;
                ctx.lineWidth = 0.7995659708976746;
                ctx.lineCap = 'round';
                ctx.lineJoin = 'miter';
                ctx.beginPath();
                ctx.moveTo(262.84571, 292.64674);
                ctx.bezierCurveTo(287.30423, 296.16433, 308.02096, 295.90318, 323.77278, 292.43510000000003);
                ctx.fill();
                ctx.stroke();
                ctx.restore();
                ctx.save();
                ctx.fillStyle = fill;
                ctx.strokeStyle = stroke;
                ctx.lineWidth = 1;
                ctx.lineCap = 'butt';
                ctx.lineJoin = 'miter';
                ctx.beginPath();
                ctx.moveTo(313.56118, 286.16302);
                ctx.lineTo(323.64349999999996, 292.63155);
                ctx.fill();
                ctx.stroke();
                ctx.restore();
                ctx.save();
                ctx.fillStyle = fill;
                ctx.strokeStyle = stroke;
                ctx.lineWidth = 1;
                ctx.lineCap = 'butt';
                ctx.lineJoin = 'miter';
                ctx.beginPath();
                ctx.moveTo(314.31633, 300.22032);
                ctx.lineTo(323.51041, 292.54153);
                ctx.fill();
                ctx.stroke();
                ctx.restore();
                ctx.restore();
                ctx.restore();
                ctx.restore();
            },
            topLeft: function(ctx) {
                ctx.save();
                ctx.beginPath();
                ctx.moveTo(0, 0);
                ctx.lineTo(140.6125, 0);
                ctx.lineTo(140.6125, 47.525002);
                ctx.lineTo(0, 47.525002);
                ctx.closePath();
                ctx.clip();
                ctx.strokeStyle = stroke;
                ctx.lineCap = 'butt';
                ctx.lineJoin = 'miter';
                ctx.miterLimit = 4;
                ctx.save();
                ctx.restore();
                ctx.save();
                ctx.transform(1.25, 0, 0, -1.25, 0, 47.525);
                ctx.save();
                ctx.scale(0.1, 0.1);
                ctx.save();
                ctx.save();
                ctx.beginPath();
                ctx.moveTo(0, 0);
                ctx.lineTo(1124.91, 0);
                ctx.lineTo(1124.91, 380);
                ctx.lineTo(0, 380);
                ctx.lineTo(0, 0);
                ctx.closePath();
                ctx.clip();
                ctx.save();
                ctx.fillStyle = fill;
                ctx.strokeStyle = stroke;
                ctx.beginPath();
                ctx.moveTo(760.371, 0);
                ctx.bezierCurveTo(358.086, 0, 59.7227, 35.4023, 50.1523, 363.695);
                ctx.bezierCurveTo(50.0312, 367.836, 53.285199999999996, 371.293, 57.425799999999995, 371.40999999999997);
                ctx.bezierCurveTo(61.5742, 371.68399999999997, 65.0234, 368.27299999999997, 65.14059999999999, 364.13699999999994);
                ctx.bezierCurveTo(75.5664, 6.57031, 432.793, 10.6523, 927.102, 16.2891);
                ctx.bezierCurveTo(988.723, 16.9922, 1052.43, 17.7148, 1117.4099999999999, 17.7148);
                ctx.bezierCurveTo(1121.55, 17.7148, 1124.9099999999999, 14.3555, 1124.9099999999999, 10.2148);
                ctx.bezierCurveTo(1124.9099999999999, 6.07422, 1121.55, 2.7148400000000006, 1117.4099999999999, 2.7148400000000006);
                ctx.bezierCurveTo(1052.5199999999998, 2.7148400000000006, 988.8479999999998,
                    1.9921900000000006, 927.2729999999999, 1.2890600000000005);
                ctx.bezierCurveTo(870.09, 0.636719, 814.27, 0, 760.371, 0);
                ctx.fill();
                ctx.stroke();
                ctx.restore();
                ctx.save();
                ctx.fillStyle = fill;
                ctx.strokeStyle = stroke;
                ctx.beginPath();
                ctx.moveTo(0, 310.793);
                ctx.lineTo(11.5625, 301.211);
                ctx.lineTo(58.6758, 358.223);
                ctx.lineTo(112.102, 307.07);
                ctx.lineTo(122.477, 317.92199999999997);
                ctx.lineTo(57.3984, 380.215);
                ctx.lineTo(0, 310.793);
                ctx.fill();
                ctx.stroke();
                ctx.restore();
                ctx.restore();
                ctx.restore();
                ctx.restore();
                ctx.restore();
                ctx.restore();
            },
            myinfoLeft: function(ctx) {
                ctx.save();
                ctx.translate(0, 0);
                ctx.beginPath();
                ctx.moveTo(0, 0);
                ctx.lineTo(64.104, 0);
                ctx.lineTo(64.104, 14.821);
                ctx.lineTo(0, 14.821);
                ctx.closePath();
                ctx.clip();
                ctx.translate(0, 0);
                ctx.translate(0, 0);
                ctx.scale(1, 1);
                ctx.translate(0, 0);
                ctx.strokeStyle = stroke;
                ctx.lineCap = 'butt';
                ctx.lineJoin = 'miter';
                ctx.miterLimit = 4;
                ctx.save();
                ctx.fillStyle = fill;
                ctx.beginPath();
                ctx.moveTo(0.922, 13.203);
                ctx.lineTo(16.155, 14.386999999999999);
                ctx.lineTo(16.235, 13.389999999999999);
                ctx.lineTo(3.316, 12.357);
                ctx.bezierCurveTo(8.315, 9.175999999999998, 31.852, -4.006, 62.826, 7.467999999999999);
                ctx.lineTo(63.295, 7.6419999999999995);
                ctx.lineTo(63.643, 6.704);
                ctx.lineTo(63.174, 6.529999999999999);
                ctx.bezierCurveTo(32.065, -4.992, 8.29, 8.046, 2.889, 11.446);
                ctx.lineTo(7.987, 0.8460000000000001);
                ctx.lineTo(7.086, 0.413);
                ctx.lineTo(1.465, 12.101);
                ctx.lineTo(0.922, 13.203);
                ctx.closePath();
                ctx.fill();
                ctx.stroke();
                ctx.restore();
                ctx.restore();
            },
        };

        $(el).each(function(index, element) {
            Odigeo._.each(['width', 'height'], function(a) {
                element.setAttribute(a, parseInt($(element).css(a), 10));
            });
            arrows[arrow](element.getContext('2d'));
        });
    };
}());
